import React, {Dispatch} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {useDispatch} from 'react-redux'
import {useParams} from 'react-router'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {IVendorServiceList} from '../../../../../interfaces/Vendors'
import ApiCalls from '../../../../../network/ApiCalls'
import {
  closeDeleteDialog,
  openDeleteDialog,
} from '../../../../../redux/actionCreators/deleteDialogActionCreators'
import {OpenVendorEditOfferDialog} from '../../../../../redux/actionCreators/vendorActionCreators'
import {DeleteActions} from '../../../../../redux/actionTypes/deleteDialogTypes'
import {VendorAction} from '../../../../../redux/actionTypes/vendorTypes'
import {decryptText} from '../../../../../utils/util'

type Props = {
  vendorService: IVendorServiceList
  refetch: () => void
}

const VendorServiceItem: React.FC<Props> = ({vendorService, refetch}) => {
  let {vendorId}: any = useParams()
  vendorId = decryptText(vendorId)
  const dispatch = useDispatch<Dispatch<VendorAction>>()
  const deleteDispatch = useDispatch<Dispatch<DeleteActions>>()

  const executeMutation = async () => {
    deleteVendorServiceMutate()
      .then((res) => {
        deleteDispatch(closeDeleteDialog())
        return res
      })
      .catch((err) => err)
  }

  const deleteVendorService = () => {
    deleteDispatch(
      openDeleteDialog(
        executeMutation,
        `Are you sure you want to delete service?`,
        `Delete Vendor Service?`
      )
    )
  }

  const queryClient = useQueryClient()
  const {mutateAsync: deleteVendorServiceMutate} = useMutation(
    () => ApiCalls.deleteVendorService(vendorService.id),
    {
      onSuccess: () => {
        refetch()
        queryClient.invalidateQueries(['Vendor Offered Services', vendorId])
      },
    }
  )

  return (
    <div
      className='w-100 w-sm-250px border rounded p-6 pb-0 d-flex flex-column justify-content-between bg-white mt-3 me-3 align-items-center position-relative'
      style={{height: 180}}
    >
      <div className='d-flex flex-column align-items-center'>
        <h2 style={{fontWeight: 400}}>{vendorService.serviceType.name}</h2>
        <small className='text-muted text-center' style={{fontWeight: 400}}>
          {vendorService.serviceType.description}
        </small>
      </div>
      <div className='d-flex flex-column w-100'>
        <div className='d-flex justify-content-end align-items-center mt-6 pt-2 border-top'>
          <button
            type='button'
            className='btn btn-link btn-sm text-danger'
            onClick={deleteVendorService}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default VendorServiceItem
